import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
// import EastIcon from '@mui/icons-material/East';
import Box from '@mui/material/Box';
import LocalIcon from '@mui/icons-material/Folder';
import FtpIcon from '@mui/icons-material/CloudUpload';
import ScpIcon from '@mui/icons-material/Security';
import { Button } from '@mui/material';

function TypeSelect() {
  const [type, setType] = React.useState(30);

  const handleChange = (event) => {
    setType(event.target.value);
  };

  return (
    <Box
      sx={{
        color: 'lightgray',
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: 'gray',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'gray',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'gray',
        },
      }}
    >
      <FormControl
        fullWidth
        sx={{
          color: 'lightgray',
          '&.Mui-focused': {
            color: 'lightgray',
          },
        }}
      >
        <Select
          sx={{
            color: 'lightgray',
            '.MuiSelect-icon': {
              color: 'gray', // Ensure the dropdown icon remains gray
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'gray', // Hover state
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'gray', // Click (focused) state
            },
            '&:hover': {
              backgroundColor: 'transparent', // Optional: keep background transparent on hover
            },
          }}
          value={type}
          onChange={handleChange}
          inputProps={{
            name: 'Type',
            id: 'uncontrolled-native',
          }}
        >
          <MenuItem value={10} sx={{ color: 'lightgray' }}>
            <FtpIcon sx={{ mr: 1 }} /> FTP
          </MenuItem>
          <MenuItem value={20} sx={{ color: 'lightgray' }}>
            <ScpIcon sx={{ mr: 1 }} /> SCP
          </MenuItem>
          <MenuItem value={30} sx={{ color: 'lightgray' }}>
            <LocalIcon sx={{ mr: 1 }} /> Local
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}


const ITEM_HEIGHT = 68;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 550,
    },
  },
};

const names = [
  'Cisco Call Manager',
  'Windows Desktop',
  'Linux Ubuntu'
];

const pushToList = [
  'Amazon Web Services',
  'Microsoft Azure',
  'Google Cloud',
  'Docker'
]

export default function PushImage() {
  const [imageName, setImageName] = React.useState([]);
  const [pushTo, setPushTo] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setImageName(
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleChangePushTo = (event) => {
    const {
      target: { value },
    } = event;
    setPushTo(
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: "center", alignItems: "center" }}>
      <TypeSelect />
      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel id="demo-multiple-checkbox-label" sx={{
          color: 'lightgray',
          '&.Mui-focused': {
            color: 'lightgray',
          }
        }}>Image</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={imageName}
          onChange={handleChange}
          input={<OutlinedInput label="Image" />}
          renderValue={(selected) => (
            <span style={{ color: 'lightgray' }}>{selected.join(', ')}</span>
          )}
          MenuProps={MenuProps}
          sx={{
            color: 'lightgray',
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 'gray',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'gray',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'gray',
            },
          }}
        >
          {names.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox
                checked={imageName.includes(name)}
                sx={{
                  color: 'lightgray',
                  '&.Mui-checked': {
                    color: 'lightgray',
                  },
                }}
              />
              <ListItemText primary={name} sx={{ color: 'lightgray' }} />
            </MenuItem>
          ))}
        </Select>

      </FormControl>
      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel id="demo-multiple-checkbox-label" sx={{
          color: 'lightgray',
          '&.Mui-focused': {
            color: 'lightgray',
          }
        }}>Push To</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={pushTo}
          onChange={handleChangePushTo}
          input={<OutlinedInput label="Image" />}
          renderValue={(selected) => (
            <span style={{ color: 'lightgray' }}>{selected.join(', ')}</span>
          )}
          MenuProps={MenuProps}
          sx={{
            color: 'lightgray',
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 'gray',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'gray',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'gray',
            },
          }}
        >
          {pushToList.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox
                checked={pushTo.includes(name)}
                sx={{
                  color: 'lightgray',
                  '&.Mui-checked': {
                    color: 'lightgray',
                  },
                }}
              />
              <ListItemText primary={name} sx={{ color: 'lightgray' }} />
            </MenuItem>
          ))}
        </Select>

      </FormControl>
      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        sx={{
          width: "32rem",
          backgroundColor: 'transparent',
          border: "1px solid gray",
          color: 'white',
          '&:hover': {
            backgroundColor: 'transparent',
          },
          marginTop: "0.8rem",
          display: "flex",
          alignItems: "center"
        }}
      >
        Push
      </Button>
    </div >
  );
}
